
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AppFooter extends Vue {
  get currentYear(): number {
    return new Date().getFullYear();
  }

  get footerLogo() {
    return this.$store.getters['Config/getFooterLogo'];
  }

  get footerAddress() {
    return this.$store.getters['Config/getFooterAddress'].split(',');
  }

  get legalBusinessName() {
    return this.$store.getters['Config/getLegalBusinessName'];
  }
}
